import styled from 'styled-components'
import TestInfoLayoutDesktop from './TestInfoLayout.desktop'
import CircleInfoArticleDesktop from './circleInfo/CircleInfoArticle.desktop'
import DetailInfoArticle from './detailInfo/DetailInfoArticle'
import SpreadScoreInfoArticleDesktop from './spreadScoreInfo/SpreadScoreInfoArticle.desktop'
import SynthesisScoreInfoArticleDesktop from './synthesisInfo/SynthesisScoreInfoArticle.desktop'
import TestUserInfoArticleDesktop from './testUserInfo/TestUserInfoArticle.desktop'

const PassedInfoBoxDesktop = () => {
  return (
    <StyledWrapper>
      <TestInfoLayoutDesktop
        title="응시자 인적사항"
        guideText="위 결과는 서비스 참여 인원 및 가채점 결과에 따라 변동될 수 있습니다."
        className="margin-bottom-48"
      >
        <TestUserInfoArticleDesktop />
      </TestInfoLayoutDesktop>
      <TestInfoLayoutDesktop
        title="종합 점수 결과"
        guideText="본 결과는 링커리어 합격 예측 서비스 이용자 데이터 기반으로, 실제 결과와 차이가 있을 수 있습니다."
        className="margin-bottom-88"
        isDisplayedCorrectRate
      >
        <SynthesisScoreInfoArticleDesktop />
      </TestInfoLayoutDesktop>
      <TestInfoLayoutDesktop
        title="전체 성적 비교"
        subText="내 성적을 전체, 상위 30%, 동일 직무 응시생과 비교합니다."
        className="margin-bottom-48"
      >
        <CircleInfoArticleDesktop />
      </TestInfoLayoutDesktop>
      <TestInfoLayoutDesktop
        title="성적 분포도"
        subText="동일한 날짜에 응시한 전체 응시생 및 동일 직무 지원자들의 성적 분포를 시각적으로 분석하여, 내 성적 위치를 파악합니다."
        className="margin-bottom-48"
      >
        <SpreadScoreInfoArticleDesktop />
      </TestInfoLayoutDesktop>
      <TestInfoLayoutDesktop
        title="영역별 세부결과 분석"
        subText="수리 및 추리 영역에서 내 성적을 다양한 응시자 그룹과 비교하여 세부적으로 분석합니다."
      >
        <DetailInfoArticle />
      </TestInfoLayoutDesktop>
    </StyledWrapper>
  )
}

export default PassedInfoBoxDesktop

const StyledWrapper = styled.div`
  width: 1100px;
  display: flex;
  flex-direction: column;
  padding: 48px 48px 40px 48px;
  background-color: #fafafa;
  border-radius: 20px;

  .margin-bottom-48 {
    margin-bottom: 48px;
  }

  .margin-bottom-88 {
    margin-bottom: 88px;
  }
`
